// Configuration types for zenky-deploy dashboard

export interface Configuration {
  id: string;
  clientId: string;
  version: number;
  appName: string;
  bundleIdAndroid: string;
  bundleIdIos: string;
  iconUrl: string;
  adaptiveIconUrl: string;
  adaptiveIconBackground?: string;
  adaptiveIconBackgroundImageUrl?: string;
  splashScreenUrl?: string; // T026: Added for splash screen upload feature
  features: Record<string, any>;
  createdAt: string;
}

export interface UpdateConfigurationRequest {
  appName: string;
  bundleIdAndroid: string;
  bundleIdIos: string;
  iconUrl: string;
  adaptiveIconUrl: string;
  adaptiveIconBackground?: string;
  adaptiveIconBackgroundImageUrl?: string;
  splashScreenUrl?: string; // T026: Added for splash screen upload feature
  features?: Record<string, any>;
}

export interface ConfigurationVersion {
  version: number;
  createdAt: string;
  appName: string;
  changes: string[];
}

// T026: Splash screen types
export type MediaType = 'image' | 'video';

export interface SplashScreenFile {
  url: string;
  mimeType: string;
  size: number;
  name: string;
}

/**
 * Helper function to determine media type from URL or MIME type
 * T026: Added for splash screen upload feature
 */
export function getMediaType(url: string, mimeType?: string): MediaType {
  // Check MIME type first if available
  if (mimeType) {
    if (mimeType.startsWith('video/')) {
      return 'video';
    }
    if (mimeType.startsWith('image/')) {
      return 'image';
    }
  }

  // Fallback to file extension
  const extension = url.toLowerCase().split('.').pop() || '';

  const videoExtensions = ['mp4', 'webm', 'mov', 'avi'];

  if (videoExtensions.includes(extension)) {
    return 'video';
  }

  // Default to image
  return 'image';
}
